import { createFileRoute } from '@tanstack/react-router';
import { OrderDetailView } from '@components/pages/OrderView/components/OrderDetailView/OrderDetailView';

export const Route = createFileRoute('/_order/orders/$orderGuid/')({
  component: OrderDetailView,
});
